import { useEffect, useRef, useState } from "react";
import { decryptData, defaulUrl } from "../components/const";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const ClassementVendeur = () => {
    const [datejour] = useState((new Date()).toISOString().slice(0, 10));
    const [date1, setDate1] = useState(datejour);
    const [date2, setDate2] = useState(datejour);
    const [isLoading, setIsLoading] = useState(false);
    const [vendeurs, setVendeurs] = useState([]);
    const toPrint = useRef();

    const handleShowByPeriode = () => {
        let status = 0;
        setIsLoading(true)
        fetch(`${defaulUrl}vendeurs/classement/${date1}/${date2}`, {
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + decryptData('ACCESS_TOKEN'),
                Accept: 'application/json',
                "Content-Type": "application/json"
            },
        }).then((response) => {
            status = response.status;
            return response.json();
        }).then(data => {
            setIsLoading(false);
            if (status === 200) {
                data?.sort((a, b) => b.montant - a.montant);
                setVendeurs(data)
            }
        })
    }

    useEffect(() => {
        handleShowByPeriode()
    }, [])

    // 🔹 Fonction PDF dynamique avec titre incluant les dates
    const printClassementVendeur = () => {
        if (!vendeurs || vendeurs.length === 0) {
            alert("Aucune donnée à imprimer !");
            return;
        }

        const doc = new jsPDF("landscape");

        const user = decryptData("USER");
        const title = `CLASSEMENT DES VENDEURS DU ${date1} AU ${date2}`;

        doc.setFontSize(18);
        doc.setTextColor(0, 123, 255);
        doc.text("FANSAN TEXTIL", 105, 20, { align: "center" });

        doc.setFontSize(14);
        doc.text(title, 105, 30, { align: "center" });

        const headers = ["N°", "PRENOMS ET NOM", "MAGASIN", "MONTANT VENTE", "MONTANT PAYE", "MONTANT IMPAYE"];

        const data = vendeurs.map((vend, i) => [
            i + 1,
            vend.vendeur?.toUpperCase(),
            vend.magasin?.toUpperCase(),
            `${vend.montant?.toLocaleString()} GNF`,
            `${vend.paye?.toLocaleString()} GNF`,
            `${vend.reste?.toLocaleString()} GNF`,
        ]);

        autoTable(doc, {
            startY: 40,
            head: [headers],
            body: data,
            headStyles: { fillColor: [52, 58, 64], textColor: 255 },
            theme: "grid",
        });

        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(10);
        doc.text(new Date().toLocaleDateString(), 105, pageHeight - 20, { align: "center" });
        doc.text(user?.droit?.toUpperCase() || "", 105, pageHeight - 10, { align: "center" });

        doc.save(`${title}.pdf`);
    }

    return (
        <div className="classement">
            <div className="row py-2">
                <div className="modal-footer justify-content-start text-primary">
                    <h6 className="">CLASSEMENT DES VENDEURS DU </h6>

                    <input type="date" className="form-control w-auto m-1" defaultValue={date1} onChange={(e) => setDate1(e.target.value)} /> AU
                    <input type="date" className="form-control w-auto m-1" defaultValue={date2} onChange={(e) => setDate2(e.target.value)} />

                    <button type="submit" className="btn btn-primary m-1" onClick={handleShowByPeriode}><i className="bx bx-show" ></i></button>
                    <button className="btn btn-primary w-auto" onClick={printClassementVendeur}>
                        <i className="bx bx-printer"></i>
                    </button>
                </div>
            </div>

            {isLoading ? <div className="loader"></div> :
                <div className="table-responsive mt-2" ref={toPrint}>
                    <table className="table table-striped table-hover table-bordered">
                        <thead className="table-dark">
                            <tr>
                                <th>N°</th>
                                <th>PRENOMS ET NOM</th>
                                <th>MAGASIN</th>
                                <th>MONTANT VENTE</th>
                                <th>MONTANT PAYE</th>
                                <th>MONTANT IMPAYE</th>
                            </tr>
                        </thead>
                        <tbody>
                            {vendeurs?.map((vend, ind) => (
                                <tr key={ind}>
                                    <td>{ind + 1}</td>
                                    <td>{vend.vendeur?.toUpperCase()}</td>
                                    <td>{vend.magasin?.toUpperCase()}</td>
                                    <td>{vend.montant?.toLocaleString()} GNF</td>
                                    <td>{vend.paye?.toLocaleString()} GNF</td>
                                    <td>{vend.reste?.toLocaleString()} GNF</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            }
        </div>
    );
}

export default ClassementVendeur;
